import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { MediatorsService } from 'src/app/modules/mediators/_services/mediators.service';
import { Mediator } from 'src/app/modules/mediators/_types/mediator';
import { CaseMediatorCreateNewComponent } from './create-new/create-new.component';

@Component({
    selector: 'app-mediator',
    templateUrl: './mediator.component.html',
    styleUrls: ['./mediator.component.scss'],
    standalone: false
})
export class CaseMediatorComponent {
  public mediators: Mediator[] = [];
  public selectedMediator: any;

  public existentCaseMediators: any[] = [];
  public caseId: string = '';

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };

  constructor(
    private mediatorsService: MediatorsService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService
  ) { }

  async ngOnInit() {
    if (this.config.data && this.config.data.existentCaseMediators) {
      this.existentCaseMediators = this.config.data.existentCaseMediators;
    }
    this.caseId = this.config.data.caseId;
  }

  public async loadData($event: any) {
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      sort: ['name']
    };

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.mediatorsService.all(params));
    this.mediators = response.data;
    this.totalRecords = response.meta["total"];

    if (this.existentCaseMediators.length > 0) {
      this.mediators = this.mediators.filter(mediator => {
        return !this.existentCaseMediators.some(existing => existing.mediator.id === mediator.id);
      });
    }
  }

  addMediator() {
    const ref = this.dialogService.open(CaseMediatorCreateNewComponent, {
      closable: true,
      modal: true,
      header: 'Nuevo mediador',
      width: '70%',
      draggable: true
    });

    ref.onClose.subscribe((mediator: Mediator) => {
      if (mediator) {
        this.dynamicDialogRef.close(mediator);
      }
    });
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  save() {
    this.dynamicDialogRef.close(this.selectedMediator);
  }
}
